import { motion, useReducedMotion } from "framer-motion";
import { cn } from "@/lib/utils";

// Realistic iPhone frame wrapping a real Nova screenshot. Lazy-loaded image.
export const PhoneMockup = ({ src, alt, className = "", float = false, delay = 0, priority = false }) => {
  const reduce = useReducedMotion();
  const animate = float && !reduce ? { y: [0, -14, 0] } : {};
  const transition = float && !reduce
    ? { duration: 7, repeat: Infinity, ease: "easeInOut", delay }
    : {};

  return (
    <motion.div
      animate={animate}
      transition={transition}
      className={cn(
        "relative rounded-[2.6rem] p-[3px] shadow-[0_30px_80px_-20px_rgba(0,0,0,0.8)]",
        className
      )}
      style={{
        background: "linear-gradient(150deg, rgba(255,255,255,0.22), rgba(255,255,255,0.03) 40%, rgba(0,240,255,0.18))",
      }}
    >
      <div className="overflow-hidden rounded-[2.4rem] border border-white/10 bg-nova-bg">
        {/* notch */}
        <div className="pointer-events-none absolute left-1/2 top-[3px] z-10 h-6 w-28 -translate-x-1/2 rounded-b-2xl bg-black" />
        <img
          src={src}
          alt={alt}
          loading={priority ? "eager" : "lazy"}
          decoding="async"
          className="block h-auto w-full"
        />
      </div>
    </motion.div>
  );
};

export default PhoneMockup;
